module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#instagram",
      toString: function () {
        return this.url;
      }
    }